import { render, staticRenderFns } from "./BadgesGalleryPage.vue?vue&type=template&id=ac7db06c"
import script from "./BadgesGalleryPage.vue?vue&type=script&lang=js"
export * from "./BadgesGalleryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports